export default __webpack_public_path__ + "static/media/navbar-img-4.88c31b37.jpg";